import { api } from '@connected/api-client';
import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';

import { queryClient } from '@/lib/query-client';

export function useProjectStatusMutation(projectVersionId: string) {
    return api.useMutation('put', '/api/v2/electrical/projects/status', {
        onSettled: () => {
            queryClient.invalidateQueries(
                elektraAppQueryOptions.project.status({
                    electricalProjectVersionId: projectVersionId,
                }),
            );
        },
    });
}
